import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchStart,
  fetchSuccess,
  fetchFailure,
  fetchOneSuccess,
  createSuccess,
  updateSuccess,
  deleteSuccess,
} from '../slices/dataSlice';

// Factory function to create CRUD thunks for any entity
export const createEntityThunks = (entityName, service) => {
  const fetchAll = createAsyncThunk(
    `${entityName}/fetchAll`,
    async (params = {}, { dispatch, rejectWithValue }) => {
      dispatch(fetchStart({ entity: entityName }));

      try {
        const response = await service.getAll(params);
        const items = response.data?.data || response.data || response || [];
        const pagination = response.data?.pagination || null;

        dispatch(fetchSuccess({
          entity: entityName,
          items: Array.isArray(items) ? items : [],
          pagination
        }));

        return response;
      } catch (error) {
        dispatch(fetchFailure({ entity: entityName, error: error.message }));
        return rejectWithValue(error.message);
      }
    }
  );

  const fetchOne = createAsyncThunk(
    `${entityName}/fetchOne`,
    async (id, { dispatch, rejectWithValue }) => {
      dispatch(fetchStart({ entity: entityName }));

      try {
        const response = await service.getById(id);
        const item = response.data?.data || response.data || response;

        dispatch(fetchOneSuccess({ entity: entityName, item }));

        return response;
      } catch (error) {
        dispatch(fetchFailure({ entity: entityName, error: error.message }));
        return rejectWithValue(error.message);
      }
    }
  );

  const create = createAsyncThunk(
    `${entityName}/create`,
    async (data, { dispatch, rejectWithValue }) => {
      dispatch(fetchStart({ entity: entityName }));

      try {
        const response = await service.create(data);
        const item = response.data?.data || response.data || response;

        dispatch(createSuccess({ entity: entityName, item }));

        return response;
      } catch (error) {
        dispatch(fetchFailure({ entity: entityName, error: error.message }));
        return rejectWithValue(error.message);
      }
    }
  );

  const update = createAsyncThunk(
    `${entityName}/update`,
    async ({ id, data }, { dispatch, rejectWithValue }) => {
      dispatch(fetchStart({ entity: entityName }));

      try {
        const response = await service.update(id, data);
        const item = response.data?.data || response.data || response;

        dispatch(updateSuccess({ entity: entityName, item: { ...item, id } }));

        return response;
      } catch (error) {
        dispatch(fetchFailure({ entity: entityName, error: error.message }));
        return rejectWithValue(error.message);
      }
    }
  );

  const remove = createAsyncThunk(
    `${entityName}/delete`,
    async (id, { dispatch, rejectWithValue }) => {
      dispatch(fetchStart({ entity: entityName }));

      try {
        const response = await service.delete(id);

        dispatch(deleteSuccess({ entity: entityName, id }));

        return response;
      } catch (error) {
        dispatch(fetchFailure({ entity: entityName, error: error.message }));
        return rejectWithValue(error.message);
      }
    }
  );

  return {
    fetchAll,
    fetchOne,
    create,
    update,
    remove,
  };
};

// Usage example:
// import vaccineService from '../../services/vaccineService';
// export const vaccineThunks = createEntityThunks('vaccines', vaccineService);
